<template lang="pug">
.d-flex.px-6.py-2.justify-content-between(v-if="$impersonate.state.isActive" id="impersonate-bar")
  .left
     .mr-2 {{ $t('impersonate_bar.title') }}
     .label.mr-8 {{ username }}
  .btn.btn-secondary.btn-xs(@click="$impersonate.exit") {{ $t('impersonate_bar.exit') }}
</template>
<style lang="scss">
#impersonate-bar {
}
</style>

<script>
export default {
    data() {
        return {}
    },
    computed: {
        username() {
            return this.$user.model.email
        },
    },
    methods: {
        async exit() {},
    },
}
</script>
